import { createContext, useContext } from 'react';

import type { NewValueParams } from '@mint-lib/ag-grid/community';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import type { UpdateColumnParams } from '../api/mutations/useUpdateColumn.js';

export type ModalDataType = NewValueParams<
  MediaPlan.MediaData,
  string | string[]
> & {
  updateColumnWithErrorHandling: (params: UpdateColumnParams) => Promise<void>;
};

export type ConfirmationModalContextType = (modalData: ModalDataType) => void;

export const ConfirmationModalContext =
  createContext<ConfirmationModalContextType | null>(null);

export const useSetConfirmationModal = () => {
  const confirmationModal = useContext(ConfirmationModalContext);

  if (!confirmationModal) {
    throw new Error(
      'useSetConfirmationModal must be used within a ConfirmationModalProvider',
    );
  }

  return confirmationModal;
};
